/* tslint:disable */
/* eslint-disable */
/**
 * Client Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ResourceType } from './ResourceType';
import {
    ResourceTypeFromJSON,
    ResourceTypeFromJSONTyped,
    ResourceTypeToJSON,
} from './ResourceType';

/**
 * A payload to update metadata schema
 * @export
 * @interface UpdateMetadataSchema
 */
export interface UpdateMetadataSchema {
    /**
     * The name of the metadata schema
     * @type {string}
     * @memberof UpdateMetadataSchema
     */
    name?: string;
    /**
     * 
     * @type {ResourceType}
     * @memberof UpdateMetadataSchema
     */
    resourceType?: ResourceType;
    /**
     * JSON Schema definition
     * @type {object}
     * @memberof UpdateMetadataSchema
     */
    schema?: object;
}

/**
 * Check if a given object implements the UpdateMetadataSchema interface.
 */
export function instanceOfUpdateMetadataSchema(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function UpdateMetadataSchemaFromJSON(json: any): UpdateMetadataSchema {
    return UpdateMetadataSchemaFromJSONTyped(json, false);
}

export function UpdateMetadataSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateMetadataSchema {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'resourceType': !exists(json, 'resourceType') ? undefined : ResourceTypeFromJSON(json['resourceType']),
        'schema': !exists(json, 'schema') ? undefined : json['schema'],
    };
}

export function UpdateMetadataSchemaToJSON(value?: UpdateMetadataSchema | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'resourceType': ResourceTypeToJSON(value.resourceType),
        'schema': value.schema,
    };
}

